import {
  AgentInLenderContext,
  AgentInSinglePaymentProviderContext,
  Lender,
  LenderMap,
  Pricing,
} from '@nemuru-eng/js-api-client';

import { getLendersFromPricing } from '@/components/modules/AgentDetail/ProvidersDetails/components/AgentPricings/utils/getLendersFromPricing';
import { AgentInLenderContextRow } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInLenderContextTable/components/AgentInLenderContextRow';
import { DefaultTableProps } from '@/types/defaultTableProps';
interface TableBodyContentProps {
  agentInContextArray: AgentInLenderContext[] | AgentInSinglePaymentProviderContext[];
  agentPricings: Pricing[];
  lenders: Lender[];
  handleDeleteCredentials: ({ agentCredentials }: { agentCredentials: AgentInLenderContext }) => void;
  handleEditCredentials: ({ agentCredentials }: { agentCredentials: AgentInLenderContext }) => void;
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
  hideColumnsForDeleteMode?: boolean;
}
export const TableBodyContent = ({
  agentInContextArray,
  agentPricings,
  lenders,
  handleDeleteCredentials,
  handleEditCredentials,
  tableProps,
  hideColumnsForDeleteMode,
}: TableBodyContentProps) => {
  if (!lenders || !agentInContextArray) return null;
  const lenderIds = lenders.map((lender) => lender.id);
  return (
    <>
      {agentInContextArray.map((agentInLenderContext) => {
        const disabled =
          !lenderIds.includes(agentInLenderContext.lenderId) ||
          !agentPricings?.some((pricing) => {
            const lenderIdsFromPricings = getLendersFromPricing(pricing).map((lenderName) =>
              LenderMap.fromLenderName(lenderName),
            );
            return (
              lenderIdsFromPricings.includes(agentInLenderContext.lenderId) &&
              pricing.product === agentInLenderContext.product &&
              pricing.program === agentInLenderContext.program
            );
          });
        return (
          <AgentInLenderContextRow
            key={agentInLenderContext.id}
            agentInLenderContext={agentInLenderContext}
            handleEditCredentials={handleEditCredentials}
            handleDeleteCredentials={handleDeleteCredentials}
            tableProps={tableProps}
            hideColumnsForDeleteMode={hideColumnsForDeleteMode}
            disabled={disabled}
          />
        );
      })}
    </>
  );
};
